import React from "react"
import { Block } from "baseui/block"
import { AdSlot } from "react-dfp"
import { get } from "lodash"

type AdSlotBlockProps = {
  type: string
}

const ads =
  process.env.GATSBY_API_URL === "https://api-staging.truevisions.co.th"
    ? {
        billboard: {
          desktop: {
            name: "TEST/topbillboard",
            sizes: [[970, 300]],
          },
          mobile: {
            name: "TEST/Billboard-Mobile",
            sizes: [[320, 100]],
          },
        },
        billboard2: {
          desktop: {
            name: "TEST/Billboard2",
            sizes: [
              [970, 300],
              [970, 250],
            ],
          },
          mobile: {
            name: "TEST/Rec1",
            sizes: [
              [336, 280],
              [300, 250],
            ],
          },
        },
        billboard3: {
          desktop: {
            name: "TEST/Billboard3",
            sizes: [
              [970, 250],
              [970, 300],
            ],
          },
          mobile: {
            name: "TEST/Rec2",
            sizes: [
              [300, 250],
              [336, 280],
            ],
          },
        },
        rect: {
          desktop: {
            name: "TEST/Rec1",
            sizes: [
              [300, 250],
              [336, 280],
            ],
          },
          mobile: {
            name: "TEST/Rec1",
            sizes: [
              [336, 280],
              [300, 250],
            ],
          },
        },
      }
    : {
        billboard: {
          desktop: {
            name: "Truevision/Topbillboard",
            sizes: [
              [970, 300],
              [970, 250],
              [728, 90],
            ],
          },
          mobile: {
            name: "Truevision/Mobile-Billboard",
            sizes: [320, 100],
          },
        },
        billboard2: {
          desktop: {
            name: "Truevision/Billboard2",
            sizes: [
              [970, 250],
              [970, 300],
            ],
          },
          mobile: {
            name: "Truevision/Rec1",
            sizes: [
              [300, 250],
              [336, 280],
            ],
          },
        },
        billboard3: {
          desktop: {
            name: "Truevision/Billboard3",
            sizes: [
              [970, 250],
              [970, 300],
            ],
          },
          mobile: {
            name: "Truevision/Rec2",
            sizes: [
              [300, 250],
              [336, 280],
            ],
          },
        },
        rect: {
          desktop: {
            name: "Truevision/Rec1",
            sizes: [
              [300, 250],
              [336, 280],
            ],
          },
          mobile: {
            name: "Truevision/Rec1",
            sizes: [
              [300, 250],
              [336, 280],
            ],
          },
        },
      }

const AdSlotBlock = ({ type }: AdSlotBlockProps) => {
  const { desktop, mobile } = get(ads, type, { name: "", sizes: [] })
  return (
    <>
      <Block
        paddingTop={"20px"}
        paddingBottom={"20px"}
        display={["none", "none", "flex"]}
        justifyContent={"center"}
        margin={"auto"}
        maxWidth={"1600px"}
      >
        <AdSlot sizes={desktop.sizes} adUnit={desktop.name} />
      </Block>
      <Block
        paddingTop={"10px"}
        paddingBottom={"10px"}
        display={["block", "block", "none"]}
        margin={"auto"}
        width={"320px"}
      >
        <AdSlot sizes={mobile.sizes} adUnit={mobile.name} />
      </Block>
    </>
  )
}

export default AdSlotBlock
